import { ConnectorStatusEnum, type Connector } from '@/types/swagger';
import ConnectorType, { getConnectorTypeSvg } from 'components/ConnectorType';
import { getVehicleIcon } from 'util/getComponentIcon';

export interface InfoProps {
  connector: Connector | null;
  status: ConnectorStatusEnum | undefined;
}

export function translateStatus(status: ConnectorStatusEnum): string {
  switch (status) {
    case ConnectorStatusEnum.Available:
      return 'Disponible';
    case ConnectorStatusEnum.Preparing:
      return 'Preparando';
    case ConnectorStatusEnum.Charging:
      return 'Cargando';
    case ConnectorStatusEnum.Finishing:
      return 'Listo';
    case ConnectorStatusEnum.Unavailable:
      return 'No disponible';
    case ConnectorStatusEnum.Faulted:
      return 'Falla de conector';
    case ConnectorStatusEnum.SuspendedEV:
      return 'Carga suspendida por vehículo';
    case ConnectorStatusEnum.SuspendedEVSE:
      return 'Carga suspendida por el cargador';
    case ConnectorStatusEnum.Reserved:
      return 'Reservado';
    default:
      return status;
  }
}

const VehicleInfo = ({ connector, status }: InfoProps) => {
  return connector?.latest_transaction ? (
    <>
      <div className="vehicle-icon">
        {getVehicleIcon(connector.latest_transaction.vehicle.class_type)}
      </div>
      <div className="d-flex flex-column ml-3">
        <h3 className="mb-3">
          <b>
            {connector.latest_transaction.vehicle.verbose_name ||
              connector.latest_transaction.vehicle.number_plate}
          </b>{' '}
          <b className="font-size-14">
            {`(${
              connector.latest_transaction.vehicle.verbose_name
                ? connector.latest_transaction.vehicle.number_plate
                : null
            })`}
          </b>
        </h3>
        <h6 className="color-bg-lightest mb-3">{connector.latest_transaction.vehicle.brand}</h6>
        <h6 className="color-bg-lightest mb-3">{connector.latest_transaction.vehicle.model}</h6>
        <h6 className="color-bg-lightest text-uppercase mb-3 d-flex align-items-center">
          <div className="mr-2 connector-type-icon">{getConnectorTypeSvg(connector)}</div>
          <b>{connector.plug_type}</b>
        </h6>
        <h6 className="color-bg-lightest text-uppercase d-flex align-items-center">
          <div className="mr-2">
            <ConnectorType connector={connector} />
          </div>
          <b>{status ? translateStatus(status) : ''}</b>
        </h6>
      </div>
    </>
  ) : null;
};

export default VehicleInfo;
